<template>
  <div id="coupons">
    <div class="container-large">
      <div class="row align-items-center">
        <div class="col-auto">
          <h2>Κουπόνια</h2>
        </div>
        <div class="col-auto ml-auto">
          <b-button size="sm" variant="primary" @click="openCreate">Δημιουργία νέου</b-button>
        </div>
      </div>
    </div>

    <div class="container-large my-3">
      <div class="row">
        <div class="col-12 col-md-6">
          <label class="small-label">Αναζήτηση</label>
          <b-form-input v-model="query.search" debounce="500" placeholder="Αναζήτηση κουπονιού με κωδικό"></b-form-input>
        </div>
      </div>
    </div>

    <div class="container-large mt-5">
      <vue-good-table
          mode="remote"
          :pagination-options="{
            enabled: true,
            total: totalCoupons,
            setCurrentPage: query.page,
            dropdownAllowAll: false,
            perPage: query.limit,
            rowsPerPageLabel: 'Ανά σελίδα',
            nextLabel: 'Επόμενη',
            prevLabel: 'Προηγούμενη',
            perPageDropdown: [10, 15, 20],
          }"
          :totalRows="totalCoupons"
          :sort-options="{ enabled: false }"
          style-class="vgt-table striped condensed bordered"
          theme="polar-bear"
          @on-page-change="params => query.page = params.currentPage"
          @on-per-page-change="params => query.limit = params.currentPerPage"
          :columns="columns"
          :rows="coupons">
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'type'">
            {{ props.row.type === 0 ? 'Ποσοστό (%)' : 'Σταθερό (€)' }}
          </span>
          <span v-else-if="props.column.field === 'amount'">
            {{ props.row.amount }}{{ props.row.type === 0 ? '%' : '€' }}
          </span>
          <span v-else-if="props.column.field === 'expires_at'">
            {{ props.row.expires_at ? formatDate(new Date(props.row.expires_at)) : 'Χωρίς λήξη' }}
          </span>
          <span v-else-if="props.column.field === 'actions'">
            <b-button size="sm" variant="warning" class="mr-1" @click.stop="openEdit(props.row)">Επεξεργασία</b-button>
            <b-button size="sm" variant="danger" @click.stop="deleteCoupon(props.row)">Διαγραφή</b-button>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
        <div slot="emptystate">Δεν βρέθηκαν κουπόνια</div>
      </vue-good-table>
    </div>

    <b-modal ref="coupon-modal" no-close-on-backdrop
             :ok-title="editingCoupon ? 'Αποθήκευση' : 'Δημιουργία'"
             cancel-title="Ακύρωση"
             :title="editingCoupon ? 'Επεξεργασία κουπονιού' : 'Δημιουργία κουπονιού'"
             @ok.prevent="saveCoupon">
      <div class="row">
        <div class="col-12 mb-3">
          <label>Κωδικός κουπονιού</label>
          <b-form-input v-model="form.name" placeholder="π.χ. WELCOME10"></b-form-input>
        </div>
        <div class="col-6 mb-3">
          <label>Τύπος έκπτωσης</label>
          <b-form-select v-model="form.type">
            <option :value="0">Ποσοστό (%)</option>
            <option :value="1">Σταθερό ποσό (€)</option>
          </b-form-select>
        </div>
        <div class="col-6 mb-3">
          <label>Ποσό</label>
          <b-form-input v-model="form.amount" type="number" min="1" :placeholder="form.type === 0 ? 'π.χ. 10 (%)' : 'π.χ. 5 (€)'"></b-form-input>
        </div>
        <div class="col-6 mb-3">
          <label>Ημερομηνία λήξης</label>
          <b-form-input v-model="form.expires_at" type="date"></b-form-input>
        </div>
        <div class="col-6 mb-3 d-flex align-items-end">
          <b-form-checkbox v-model="noExpiry">Χωρίς ημερομηνία λήξης</b-form-checkbox>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      coupons: [],
      totalCoupons: 0,
      editingCoupon: null,
      noExpiry: true,
      query: {
        limit: 10,
        page: 1,
        search: '',
      },
      form: {
        name: '',
        type: 0,
        amount: null,
        expires_at: null,
      },
      columns: [
        { label: 'Κωδικός', field: 'name' },
        { label: 'Τύπος', field: 'type' },
        { label: 'Ποσό', field: 'amount' },
        { label: 'Λήξη', field: 'expires_at' },
        { label: 'Ενέργειες', field: 'actions', sortable: false },
      ],
    }
  },

  watch: {
    'query.page'() { this.getCoupons() },
    'query.search'() { this.query.page = 1; this.getCoupons() },
    noExpiry(val) { if (val) this.form.expires_at = null },
  },

  mounted() {
    this.getCoupons();
  },

  methods: {
    getCoupons() {
      let query = { ...this.query };
      query.offset = (query.page - 1) * query.limit;
      this.axios.get('/admin/coupons', { params: query }).then(res => {
        this.coupons = res.data.rows;
        this.totalCoupons = res.data.count;
      }).catch(() => {
        this.$notify({ type: 'error', title: 'Σφάλμα', text: 'Δεν ήταν δυνατή η φόρτωση των κουπονιών.' });
      });
    },

    openCreate() {
      this.editingCoupon = null;
      this.form = { name: '', type: 0, amount: null, expires_at: null };
      this.noExpiry = true;
      this.$refs['coupon-modal'].show();
    },

    openEdit(coupon) {
      this.editingCoupon = coupon.id;
      this.form = {
        name: coupon.name,
        type: coupon.type,
        amount: coupon.amount,
        expires_at: coupon.expires_at,
      };
      this.noExpiry = !coupon.expires_at;
      this.$refs['coupon-modal'].show();
    },

    saveCoupon() {
      const data = { ...this.form };
      if (this.noExpiry) data.expires_at = null;

      const request = this.editingCoupon
        ? this.axios.put('/admin/coupons/' + this.editingCoupon, data)
        : this.axios.post('/admin/coupons', data);

      request.then(() => {
        this.$notify({ type: 'success', title: 'Επιτυχία', text: this.editingCoupon ? 'Το κουπόνι ενημερώθηκε.' : 'Το κουπόνι δημιουργήθηκε.' });
        this.$refs['coupon-modal'].hide();
        this.getCoupons();
      }).catch(() => {
        this.$notify({ type: 'error', title: 'Σφάλμα', text: 'Δεν ήταν δυνατή η αποθήκευση.' });
      });
    },

    deleteCoupon(coupon) {
      if (!confirm('Θέλετε σίγουρα να διαγράψετε το κουπόνι "' + coupon.name + '";')) return;
      this.axios.delete('/admin/coupons/' + coupon.id).then(() => {
        this.$notify({ type: 'success', title: 'Επιτυχία', text: 'Το κουπόνι διαγράφηκε.' });
        this.getCoupons();
      }).catch(() => {
        this.$notify({ type: 'error', title: 'Σφάλμα', text: 'Δεν ήταν δυνατή η διαγραφή.' });
      });
    },
  },
}
</script>
